"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalatttvDisclaimerNewShortPathCms = void 0;
var LegalatttvDisclaimerNewShortPathCms = /** @class */ (function () {
    function LegalatttvDisclaimerNewShortPathCms() {
        this.legalText = "<p>The card you provide below will be used for any amount due\n                today and for future AT&amp;T TV monthly payments.\n                We'll start charging you when you activate service on your TV, <b><u>or</u></b> on [[startDate]],\n                whichever comes first. You agree the card you provide below will be used for any amount due today and for future AT&amp;T TV monthly payments.\n                We'll start charging you on a monthly basis when you activate service on your TV,\n                <b><u>or</u></b> on [[startDate]], whichever comes first.</p>\n";
        this.shortLegalLinkLabel = 'See additional details';
    }
    return LegalatttvDisclaimerNewShortPathCms;
}());
exports.LegalatttvDisclaimerNewShortPathCms = LegalatttvDisclaimerNewShortPathCms;
//# sourceMappingURL=LegalatttvDisclaimerNewShortPathlCms.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/PaymentDetailsPanel/PaymentScheduleModal/LegalatttvDisclaimerNewShortPathlCms.cms.js
// module id = 2033
// module chunks = 8